import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/CustomersApi/Guest";
import { validateForm } from "utils/validation";
import { GuestValidation } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditGuestForm from "./Componates/EditGuestForm";
import fields from "../json/GuestFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const countryDialCodeField = { name: "country_dial_code" };

const EditGuest = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Memoized — stable reference across renders, prevents effect loops in
  // useFetchFormDataById / useFormChange that depend on this array
  const allFields = useMemo(() => [...formdata, countryDialCodeField], [formdata]);

  const initialValues = useMemo(
    () => allFields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {}),
    [allFields]
  );

  const { values, errors, handleChange, handleFileChange, setErrors, setValues } = useFormChange(
    initialValues,
    GuestValidation
  );

  const { loading: loadingFetch } = useFetchFormDataById(id, allFields, GetById, setValues);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      if (typeof vals.id_proof_front === "string") delete vals.id_proof_front;
      if (typeof vals.id_proof_back === "string") delete vals.id_proof_back;

      const err = validateForm(vals, GuestValidation);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Guest Updated successfully"
  );

  console.log("values",values)

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditGuestForm
        fields={allFields}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update Guest"
        handleFileChange={handleFileChange}
        id_proof_frontPreview={values.id_proof_frontPreview || values.id_proof_front}
        id_proof_backPreview={values.id_proof_backPreview || values.id_proof_back}
      />
    </>
  );
};

export default EditGuest;